<template>
  <main>
    <!-- BANNER -->
    <!-- <RysBanner2
      :page="page"
      :mobilebanner="true"
    /> -->

    <div class="banner">
      <div class="bg">
        <div class="container">
          <div class="img-wrapper">
            <img
              v-if="page.acf.banner_image"
              :src="page.acf.banner_image.url"
              :alt="page.acf.banner_image.alt"
            >
          </div>
        </div>
      </div>

      <div class="text">
        <div class="container">
          <div class="inner-text">
            <h1 v-html="stripBlockTags(page.acf.banner_text)" />
            <div
              class="sub-header"
              v-html="stripBlockTags(page.acf.banner_sub_text)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- DYNAMIC SECTIONS -->
    <RysDynamicSections :sections="page.acf.sections" />
  </main>
</template>

<script>
import stripBlockTags from '@/utils/strip-block-tags';
import yoastToVueMeta from '@/utils/yoast-to-vue-meta';

export default {
  name: 'Rys2024Program',

  async setup() {
    const wpJson = useWp();

    const { data: page, error: pageError } = await useAsyncData(
      'page-2024-program',
      () => wpJson.pages.getBySlug('2024-program')
    );

    if (pageError.value) {
      throw createError({ status: 500, cause: pageError.value });
    }

    if (!page.value) {
      throw createError({ statusCode: 404 });
    }

    return { page };
  },

  head() {
    return yoastToVueMeta(this.page);
  },

  methods: {
    stripBlockTags
  }
};
</script>

<style lang="scss" scoped>
@use 'sass:math';

$height: 350px;

.banner {
  position: relative;
  overflow: hidden;
  height: $height;
  background-color: $thd-white;

  .bg {
    height: 100%;
    position: relative;
    z-index: 0;

    $img-height: 350px;

    /* &::before,
    &::after {
      content: '';
      position: absolute;
      right: 0;
      width: 0;
      height: 0;
      border-left: math.div($img-height, 2) solid transparent;
      z-index: 2;

      @media screen and (min-width: $breakpoint-lg) {
        display: none;
      }
    }

    &::before {
      top: 0;
      border-top: math.div($img-height, 2) solid $thd-orange;
    }

    &::after {
      bottom: 0;
      border-bottom: math.div($img-height, 2) solid $thd-orange;
    } */

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 0;
      transform: translateX(-50%);
      border-top: math.div($img-height, 2) solid transparent;
      border-bottom: math.div($img-height, 2) solid transparent;
      border-left: math.div($img-height, 2) solid $thd-orange;
    }

    .container {
      display: flex;
      justify-content: center;
      height: 100%;
      padding: 0;
      max-width: unset;

      @media screen and (min-width: $breakpoint-lg) {
        justify-content: flex-end;
        padding-left: 24px;
        padding-right: 24px;
        max-width: calc(100% - 48px);
      }

      .img-wrapper {
        width: 50%;
        display: flex;
        justify-content: center;
      }

      img {
        height: 100%;
      }
    }
  }

  .text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .container {
      box-sizing: border-box;
      height: 100%;
      padding: 0;

      .inner-text {
        display: none;
        position: relative;
        box-sizing: border-box;
        flex-direction: column;
        justify-content: center;
        color: $thd-white;
        text-align: left;
        white-space: nowrap;
        background-color: $thd-orange;
        height: 100%;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100vw;
          width: 100vw;
          height: 100%;
          background-color: $thd-orange;
        }

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 100%;
          width: 0;
          height: 0;
          border-top: math.div($height, 2) solid transparent;
          border-bottom: math.div($height, 2) solid transparent;
          border-left: math.div($height, 2) solid $thd-orange;
        }

        @media screen and (min-width: $breakpoint-lg) {
          display: inline-flex;
        }

        h1 {
          text-transform: uppercase;
          font-size: 58px;
          line-height: 1;
          font-weight: 400;
          font-stretch: condensed;
          margin: 0;
        }

        .sub-header {
          font-size: 18px;
          font-weight: 400;
          line-height: 24px;
          margin: 12px 0;
          text-transform: none;

          @media screen and (min-width: $breakpoint-lg) {
            font-size: 24px;
            line-height: 36px;
            letter-spacing: -0.03em;
          }
        }
      }
    }
  }
}
</style>
